(function() {

	angular.module( "ATMGurus" )

	/**
	*
	*	Company Input
	*
	*	fetches customer's companies and calls dropdownInput
	*
	*/

	.directive( "companyInput", [
		"ApiQuery",
		"$filter",
		"User",
		function( ApiQuery, $filter, User ) {
			return {
				restrict: "AE",
				template: '<div><span ng-if="loading">Loading Companies...</span><dropdown-input ng-model="value" data="data" selection="selection"></dropdown-input></div>',
				require: "ngModel",
				link: function( scope, element, attrs, ngModel ) {

					scope.$watch( 'selection', function( nv, ov ) {
						if ( angular.isDefined( nv ) && !angular.equals( nv, ov ) ) {
							if ( angular.isDefined( nv.customer_name ))
								ngModel.$setViewValue( nv.customer_name );
							else
								ngModel.$setViewValue( nv );
						}
					});

				},
				controller: ["$scope", "$element", "$attrs", "ApiQuery", function( $scope, $element, $attrs, ApiQuery ) {

					var userData = User.getUserData();
					$scope.data = [];
					$scope.loading = true;


					ApiQuery("customer/company-name-list", "", "GET")
						.then(response => {
							$scope.loading = false;
							// $scope.selection = userData.billingAddress.customer_name;
							if (response.data.data.indexOf(userData.billingAddress.customer_name) === -1) {
								$scope.data.push(userData.billingAddress.customer_name);
							}
							$scope.data = $scope.data.concat(response.data.data);
							$scope.data.sort();
						});

				}]
			};
		}
	]);
})();


// WEBPACK FOOTER //
// ./src/app/directives/company-input.js